"use client";
import Link from "next/link";
import type { Route } from "next";
import { useTranslations } from "next-intl";
import { Button } from "@/components/ui/button";
import { useAuctionRuntime } from "./auction-runtime";
export function AuctionNotices() {
  const r = useAuctionRuntime(),
    t = useTranslations("auctions"),
    common = useTranslations("auctionTemplates");
  if (!r.ready || (r.available && !r.record && !r.feedback)) return null;
  return (
    <aside
      data-slot="auction-notices"
      data-debug-source="src/components/auctions/auction-notices.tsx"
      className="m-4 min-w-0 space-y-3 text-sm [overflow-wrap:anywhere]"
      aria-live="polite"
    >
      {!r.available ? (
        <div className="space-y-2">
          <p role="alert">{t("feedback.storage")}</p>
          <Button variant="outline" onClick={r.restore}>
            {common("retry")}
          </Button>
        </div>
      ) : null}
      {r.record ? (
        <div className="flex flex-wrap items-center gap-3">
          <p>{t("unknownCommand")}</p>
          <Button
            variant="outline"
            disabled={r.pending || r.denied}
            onClick={() => void r.lookup()}
          >
            {common("lookup")}
          </Button>
        </div>
      ) : null}
      {r.feedback ? (
        <p role={r.feedback === "success" ? "status" : "alert"}>
          {r.feedback === "success"
            ? t("commandCompleted")
            : r.feedback === "unknown"
              ? t("unknownCommand")
              : t(`feedback.${r.feedback}`)}
        </p>
      ) : null}
      {r.completedId ? (
        <Button asChild variant="outline">
          <Link href={`/auctions/${r.completedId}` as Route}>
            {t("openSaved")}
          </Link>
        </Button>
      ) : null}
    </aside>
  );
}
